export default "__VITE_ASSET__dB64Ki3Q__"